export default {
      id: "product_3_month-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#product_3_month",
      toString: function () {
        return this.url;
      }
    }